module.exports = __webpack_public_path__ + "static/media/Artboard14.212c5db1.png";